/**
 * Shared merchant address form state + async hydration for country/city/region cascades.
 */

export function buildMerchantAddressPayload(form) {
  const payload = { ...form };
  if (payload.merchant_country_id) {
    payload.country_id = Number(payload.merchant_country_id);
  } else {
    payload.country_id = null;
  }
  delete payload.merchant_country_id;
  return payload;
}

export function buildMerchantFormFromMerchant(merchant, { branchId = '' } = {}) {
  const regionId = merchant?.custom_region && !merchant?.region_id
    ? '__other__'
    : (merchant?.region_id || '');
  return {
    name: merchant?.name || '',
    contact_person: merchant?.contact_person || '',
    phone: merchant?.phone || '',
    email: merchant?.email || '',
    address: merchant?.address || '',
    city: merchant?.city || '',
    city_id: merchant?.city_id ? String(merchant.city_id) : '',
    region_id: regionId ? String(regionId) : '',
    custom_region: merchant?.custom_region || '',
    merchant_country_id: merchant?.country_id ? String(merchant.country_id) : '',
    address_description: merchant?.address_description || '',
    address_lat: merchant?.address_lat ?? '',
    address_lng: merchant?.address_lng ?? '',
    username: merchant?.username || '',
    password: '',
    branch_id: merchant?.branch_id ? String(merchant.branch_id) : (branchId ? String(branchId) : ''),
  };
}

export async function hydrateMerchantAddressForm(api, merchant, companySettings = null, { useCompanyDefault = false } = {}) {
  let countryId = merchant?.country_id || null;
  let cities = [];
  let regions = [];

  if (!countryId && merchant?.city_id) {
    try {
      const cityData = await api.getCity(merchant.city_id);
      countryId = cityData?.country_id || null;
    } catch {
      /* ignore */
    }
  }

  if (!countryId && useCompanyDefault && companySettings?.country_id) {
    countryId = companySettings.country_id;
  }

  if (countryId) {
    try {
      const citiesData = await api.getCities(countryId);
      cities = Array.isArray(citiesData) ? citiesData : [];
    } catch {
      cities = [];
    }
  }

  if (merchant?.city_id) {
    try {
      const regionsData = await api.getRegions(merchant.city_id);
      regions = Array.isArray(regionsData) ? regionsData : [];
    } catch {
      regions = [];
    }
  }

  return {
    patch: {
      merchant_country_id: countryId ? String(countryId) : '',
    },
    cities,
    regions,
  };
}

export function merchantCountryLabel(merchant) {
  if (!merchant?.country_name) return '—';
  return merchant.country_name;
}

export function merchantRegionLabel(merchant) {
  if (!merchant) return '—';
  return merchant.custom_region || merchant.region_name || '—';
}

export function merchantCityLabel(merchant) {
  if (!merchant) return '—';
  return merchant.city || merchant.city_name || '—';
}
